module.exports = __webpack_public_path__ + "static/media/advantage1.7732114b.png";